import type { Partner } from '@src/types';

export const getCurrentPartner = (): Partner | null => {
  try {
    const currentPartnerJson = sessionStorage.getItem('selectedPartner');
    if (!currentPartnerJson) {
      return null;
    }
    return JSON.parse(currentPartnerJson);
  } catch (error) {
    console.error('Error reading partner from store:', error);
    return null;
  }
};

export const requirePartner = (): Partner => {
  const partner = getCurrentPartner();
  if (!partner?.code) {
    throw new Error('Please select a partner to access catalog data. Go to Partner Select to choose a partner.');
  }
  return partner;
};